import FormButtons from "components/FormButtons"
import { ChangeEvent, useEffect, useState, useCallback } from "react"
import { useTranslation } from "react-i18next"
import { Box, TextInput } from "@strapi/design-system"
import { Brand } from "types"

const BrandForm = (props: {
  brand: Brand
  setBrand: (brand: Brand) => void
  loading: boolean
  handleSave: () => void
}) => {
  const brand = props.brand

  const validateForm = useCallback(() => {
    if (!brand.name || brand.name.trim().length === 0) return false

    if (!brand.slug || brand.slug.trim().length === 0) return false

    if (!brand.sub || brand.sub.trim().length === 0) return false

    return true
  }, [brand])

  const [submitable, setSubmitable] = useState(validateForm())
  const { t } = useTranslation()

  useEffect(() => {
    ;(async () => {
      setSubmitable(validateForm())
    })()
  }, [brand, validateForm])

  return (
    <>
      <Box style={{ paddingBottom: "18px" }}>
        <TextInput
          required
          label={t("slug")}
          name="slug"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            props.setBrand({
              ...brand,
              slug: e.target.value,
            })
            setSubmitable(validateForm())
          }}
          value={brand.slug}
        />
      </Box>
      <TextInput
        required
        label={t("name")}
        name="name"
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          props.setBrand({
            ...brand,
            name: e.target.value,
          })
          setSubmitable(validateForm())
        }}
        value={brand.name}
      />
      <Box style={{ paddingBottom: "18px" }}>
        <TextInput
          required
          label={t("sub")}
          name="sub"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            props.setBrand({
              ...brand,
              sub: e.target.value,
            })
            setSubmitable(validateForm())
          }}
          value={brand.sub}
        />
      </Box>

      <FormButtons
        saveDisabled={!submitable}
        loading={props.loading}
        onSave={props.handleSave}
        cancelLink={`/brands`}
      />
    </>
  )
}

export default BrandForm
